// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__37nQc","upload":"Small_upload__1AH8C","imageWrap":"Small_imageWrap__wVeVT","removeBtn":"Small_removeBtn__3g2hV"};